import __base_store from '@/store/__base_store'

/**
 * Store de estados de movimientos de depósito (modelo `deposit_movement_status`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'deposit_movement_status',
	},
})

